/* eslint-disable*/
import VueStoreService from './VueStoreService';
const ImportService = {
  //Importación
  async getImports(url, store) {
    var resp = await VueStoreService.get("import-purchase" + url, store)
    return resp;
  },
  async getImportById(import_id, store) {
    var resp = await VueStoreService.get("import-purchase/" + import_id, store)
    return resp;
  },  
  async saveImport(data, store) {
    var resp = await VueStoreService.post("import-purchase", data, store)
    return resp;
  },
  async updateImport(import_id, data, store) {
    var resp = await VueStoreService.patch("import-purchase/" + import_id, data, store)
    return resp;
  },
  async deleteImport(import_id, store) {
    var resp = await VueStoreService.delete("import-purchase/" + import_id, store)
    return resp;
  },
  //Detalle Importación
  async getDetails(url, store) {
    var resp = await VueStoreService.get("detail-import"+ url, store)
    return resp;
  },
  async saveDetailImport(data, store) {
    var resp = await VueStoreService.post("detail-import", data, store)
    return resp;
  },
  async deleteDetailImport(import_id, store) {
    var resp = await VueStoreService.delete("detail-import/" + import_id, store)
    return resp;
  },
}

export default ImportService;